import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay
} from '@chakra-ui/react'
import PatientForm from './components/PatientForm'
import { type DoctorType } from '../../../../../model/doctor'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import { type Patient } from '../../../../../model/patient'

interface Props {
  historySchema: DoctorType['schema']['history']
  isOpen: boolean
  onClose: () => void
  isEditMode?: boolean
  currentPatient?: Patient
}

export default function PatientModal({ isOpen, onClose, ...restProps }: Props) {
  const { locale } = useIntl()

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      placement={locale.startsWith('ar') ? 'left' : 'right'}
    >
      <DrawerOverlay backdropFilter="blur(2px)" />
      <DrawerContent>
        <DrawerHeader borderBottom="1px solid" borderColor="gray.200">
          <FormattedMessage
            {...(restProps.isEditMode
              ? messages.editPatient
              : messages.addPatient)}
          />
        </DrawerHeader>
        <DrawerCloseButton />
        <DrawerBody overflowY="auto" p={0}>
          <PatientForm onClose={onClose} {...restProps} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}
